export const formatDateForGraphQL = (date: Date | string | null | undefined): string | undefined => {
  if (!date) return undefined;

  if (typeof date === 'string') {
    return date.includes('T') ? date.split('T')[0] : date;
  }

  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d.toISOString().split('T')[0];
};
